import React, { useEffect, useMemo, useRef } from 'react';
import { ClassNameProps, Pair } from '@/Types';
import styles from './FormValue.scss';
import cn from 'classnames';

type Props = {
  value?: string | number;
  type?: 'string' | 'integer' | 'currency' | 'weight' | 'size';
  options?: Pair<unknown>[];
} & ClassNameProps;

export const FormValue = ({ value = '', type = 'string', options, className }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && typeof ref.current.scroll == 'function') {
      ref.current.scroll({ left: 0 });
    }
  }, [value]);

  const formattedValue = useMemo(() => {
    if (options) {
      return options?.find((option) => option.key == value)?.value ?? value;
    }

    switch (type) {
      case 'integer':
        return Number(value).toIntegerString();

      case 'currency':
        return Number(value).toCurrencyString();

      case 'weight':
        return Number(value).toWeightString();

      case 'size':
        return Number(value).toSizeString();

      case 'string':
      default:
        return value;
    }
  }, [value, options]);

  return (
    <div ref={ref} className={cn(styles.formValue, className)} title={String(value)} tabIndex={-1}>
      <span>{formattedValue}</span>
    </div>
  );
};
